import type { StudioDepartureKitStatusV1 } from "@enrein/shared-contracts";
import { humanDepartureKitIssuanceLabel } from "../../studio-shared/orchestration/project-phase.js";
import { GuidedFlowCopy } from "../primitives/GuidedPrimitives.js";

export function GuidedHandoffPanel({
  departureKit,
  exportRunId,
  error,
}: {
  readonly departureKit: StudioDepartureKitStatusV1 | null;
  readonly exportRunId: string | null;
  readonly error: string | null;
}) {
  return (
    <div className="enrein-guided-handoff-panel" aria-label="Departure Kit handoff">
      <GuidedFlowCopy title="Departure Kit" kicker="Handoff">
        <p className="enrein-guided-muted">
          Ownership-grade export bundle for client delivery after approval.
        </p>
      </GuidedFlowCopy>
      {departureKit ? (
        <dl className="enrein-guided-handoff-meta">
          <div>
            <dt>Status</dt>
            <dd>{humanDepartureKitIssuanceLabel(departureKit.issuanceStatus)}</dd>
          </div>
          {exportRunId ? (
            <div>
              <dt>Run</dt>
              <dd className="enrein-guided-mono">{exportRunId}</dd>
            </div>
          ) : null}
          {departureKit.artifactSetHash ? (
            <div>
              <dt>Version fingerprint</dt>
              <dd className="enrein-guided-mono">{departureKit.artifactSetHash.slice(0, 16)}…</dd>
            </div>
          ) : null}
        </dl>
      ) : (
        <p className="enrein-guided-muted">Handoff status loads when export starts.</p>
      )}
      {error ? <p className="enrein-guided-validation">{error}</p> : null}
    </div>
  );
}
